import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useAdminUi } from "../../hooks/useAdminUi";

export default function PageHeader({ title, crumbs = [] }) {
  const { ui } = useAdminUi();

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "flex-start", sm: "center" }}
      spacing={{ xs: 0.75, sm: 0 }}
      sx={{ mb: 2, rowGap: 0.5 }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: { xs: 22, sm: 26 },
            fontWeight: 700,
            color: ui.ink,
            letterSpacing: "-0.03em",
            lineHeight: 1.25,
          }}
        >
          {title}
        </Typography>
      </Box>
      {crumbs.length > 0 ? (
        <Stack direction="row" spacing={0.35} alignItems="center" flexWrap="wrap" useFlexGap>
          {crumbs.map((c, i) => (
            <React.Fragment key={`${c}-${i}`}>
              <Typography
                sx={{
                  fontSize: 12,
                  color: i === crumbs.length - 1 ? ui.inkMuted : ui.inkSoft,
                  fontWeight: i === crumbs.length - 1 ? 600 : 400,
                  letterSpacing: "normal",
                  lineHeight: 1.4,
                }}
              >
                {c}
              </Typography>
              {i < crumbs.length - 1 ? (
                <KeyboardArrowRightIcon sx={{ fontSize: 14, color: ui.inkSoft, opacity: 0.7 }} />
              ) : null}
            </React.Fragment>
          ))}
        </Stack>
      ) : null}
    </Stack>
  );
}
